import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../../store/auth-context";
 
import classes from "../../../styles/Login.module.css";

const Signup = () => {
  const emailRef = React.useRef();
  const passwordRef = React.useRef();
  const [isLoading, setIsLoading] = React.useState(false);
  const authCtx = React.useContext(AuthContext);
  const navigation = useNavigate();
  

  const submitHandler = async (e) => {
    e.preventDefault();
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    emailRef.current.value="";
    passwordRef.current.value="";
    if (email.trim().length === 0 || password.trim().length === 0) {
      alert("Please enter email and password");
      return;
    }

    console.log("submitted form");
    setIsLoading(true);
    const res = await fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyBl_25ukyu4KjPpOcY9EkehUIX0qChNTO0",
      {
        method: "POST",
        body: JSON.stringify({
          email: email,
          password: password,
          returnSecureToken: true,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setIsLoading(false);
    if (!res.ok) {
      return res.json().then((data) => {
        if (data || data.error || data.error.message)
          throw new Error(data.error.message);
      });
    }
    navigation("/blog", { replace: true });
    const data = await res.json();
    authCtx.login(data.idToken);
  };

  return (
    <section className={classes.auth}>
    <h1>Create Account</h1>
  <form onSubmit={submitHandler}>
    <div className={classes.control}>
      <label htmlFor="email">Email</label>
      <input
        type="email"
        id="email"
        name="email"
        placeholder="Email"
        ref={emailRef}
      />
    </div>
    <div className={classes.control}>
      <label htmlFor="password">Password</label>
      <input
        type="password"
        id="password"
        name="password"
        placeholder="Password"
        ref={passwordRef}
      />
    </div>
    <div className={classes.actions}>
      <Link to="/login">Already have a account</Link>
      <button type="submit">
        {!isLoading && "Next"}
        {isLoading && "Loading..."}
      </button>
    </div>
  </form>
</section>
  );
};

export default Signup;
